<h3 mat-dialog-title >
    <b>Boleta Renda Fixa</b> 
</h3>
     
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.cliente_id == null">
    <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
        <mat-label>Cliente</mat-label>
        <input 
            matInput 
            placeholder="Digite o nome ou conta de um cliente" 
            aria-label="Cliente"  
            [formControl]="cliente" 
            name="cliente" 
            required
            [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
            <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                <span> {{cliente.nome}}</span> |
                <small>Conta: {{cliente.numero_xp }}</small>
            </mat-option>
        </mat-autocomplete>
        <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
        <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
    </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Produto</mat-label>
        <mat-select 
            placeholder="Produto"
            [(value)]="model.produto_id" 
            [formControl]="produto_id"
            name="produtos_id"
            (selectionChange)="selectRoa($event)"
        >
                <mat-option *ngFor="let produto of listProduto" [value]="produto.id">{{produto.nome}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerProduto"></mat-spinner>
    </mat-form-field>
</div>


<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.id != null">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Status</mat-label>
        <mat-select 
            placeholder="Status"
            [(value)]="model.status_id" 
            [formControl]="status_id"
            name="status_id"
            *ngIf="data" >
                <mat-option *ngFor="let status of listStatus" [value]="status.id">{{status.nome}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>
    </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">                        
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Observação</mat-label>
        <textarea 
            matInput 
            placeholder="Observação" 
            [formControl]="observacao" 
            name="observacao"
            [rows]="5">
        </textarea>                                        
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutAlign="space-between" >
    <mat-radio-group 
        required 
        [formControl]="compra_venda" 
        fxLayout="row"
    >        
        <mat-radio-button value="COMPRA" class="py-8" style="margin-right: 20px;">
            <span class="mat-h4 m-0">Compra</span>
        </mat-radio-button>

        <mat-radio-button value="VENDA" class="py-8" style="margin-right: 20px;">
            <span class="mat-h4 m-0">Venda</span>                        
        </mat-radio-button>

        <mat-radio-button value="COMPRA/VENDA" class="py-8" style="margin-right: 20px;">
            <span class="mat-h4 m-0">Compra/Venda</span>                        
        </mat-radio-button>

    </mat-radio-group>

    <div mat-dialog-content>
        <input hidden type="file" #fileInput ng2FileSelect [uploader]="uploader"/>
        <button mat-button (click)="fileInput.click()" tabindex="-1" >
            <mat-icon>cloud_upload</mat-icon>
            <span>
                Clique aqui para anexar uma nota de negociação
            </span> 
        </button>
    </div>

</div>

<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <p style="text-align: center; color: #030a31;">
                <b>Qual o valor</b> que deseja <b>{{texto}}</b> ?
            </p>
            <mat-form-field style="width: 100%">                
                <input 
                    matInput 
                    placeholder="Valor" 
                    [formControl]="valor" 
                    required
                    style="font-size: 30px;"
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                    maxlength="255"
                    (keypress)="getReceitaRecebidaAssessor()"
                    >
                <mat-error *ngIf="valor.invalid">{{getErrorValorMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>

<div 
    fxLayout="row" 
    fxLayoutAlign="space-between center"
    *ngIf="vlr_spread.value != 0 || receita_recebida.value != 0"
>
    <mat-form-field         
        floatLabel="always" 
        fxFlex="49" 
        appearance="outline"         
    >
        <mat-label>ROA Prosperidade</mat-label>
        <input 
            matInput 
            placeholder="SPREAD" 
            [formControl]="vlr_spread"
            currencyMask 
            maxlength = "9" 
            readonly
            [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }"
        > 
    </mat-form-field>


    <mat-form-field
        floatLabel="always" 
        fxFlex="49" 
        appearance="outline"
    >
        <mat-label>Receita Estimada Bruta (A Dividir)</mat-label>
        <input 
            matInput 
            placeholder="SPREAD" 
            [formControl]="receita_recebida"
            currencyMask 
            maxlength = "9" 
            readonly
            [options]="{  suffix: '', prefix: 'R$ ', thousands: '.', decimal: ',' }"
        > 
    </mat-form-field>
</div>


<div mat-dialog-actions style="text-align: center; margin-top: 20px;">
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()">
        Cancelar
    </button>
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1">
        Confirmar
    </button>
</div>